import * as React from 'react';
import Joyride from '@pry-financials/react-joyride';
import { getSteps } from '../results/school-search-tour'

function SearchTour(props) {
    function henbleSteps(data) {
        const el = Array.from(document.getElementsByClassName('results-list') as HTMLCollectionOf<HTMLElement>);
        const steps = getSteps(props.mode, props.resultsMode);
        if (data.action == 'update') {
            const stepTarget = (steps[data.index].target as string);
            el[0].style.overflow = stepTarget.includes('result-card') || stepTarget.includes('cel-prek') ?  'hidden' : 'auto';
        }
        if (data.action == 'reset') {
            el[0].style.overflow = 'auto';

            props.setRun(false);
        }
    }

    return <Joyride
        callback={henbleSteps}
        continuous
        hideBackButton
        run={props.run}
        showProgress={false}
        floaterProps={{ disableAnimation: true }}
        locale={{ skip: (<span className="stepSkipBtn"></span>) }}
        showSkipButton
        scrollOffset={300}
        scrollToFirstStep={true}
        disableScrollParentFix={true}
        steps={getSteps(props.mode, props.resultsMode)}
        styles={{
            tooltipContent: {
                padding: '0 15px 0 10px',
            },
            buttonNext: {
                backgroundColor: '#1d48c0'
            },
            buttonSkip: {
                position: 'absolute',
                top: '7px',
                right: '11px',
                padding: '3px'
            },
            
          
        }}
    />
}
export default SearchTour;